import React from 'react';
import {Redirect, useLocation} from 'react-router-dom';
import {getCanonicalSystemSettingsLocation} from '../Helper/SystemSettings';

export default function LegacySystemSettingsRedirect() {
	const {search, hash} = useLocation();

	return <Redirect to={getCanonicalSystemSettingsLocation({search, hash})}/>;
}
